var colorsItens = [
    '#17335E', '#076EB6', '#434085', '#36BB94', '#5EE2A0', '#FF6565', '#FEC163', '#FFA177', '#BDA9EA', '#34cdde', '#913167', '#073223',
    '#bb7526', '#b324d8', '#815952', '#05f2bf', '#0ca0aa', '#8f3a90', '#48fb10', '#1f7211', '#0fc10c', '#978d7b', '#0167b0', '#7e36c9',
    '#c1c763', '#13b5a1', '#945075', '#6bdcc4', '#188bbe', '#637011', '#e0cc57', '#9e9ec0', '#d203b9', '#0a5095', '#b5124a', '#00c352'
];

export default colorsItens;


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/variaveis-grafico.js